import { HttpClient } from "@angular/common/http";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { environment } from "src/environments/environment";
import {
  SettingsService,
  AuthenticationService,
  ModalService,
  MarathonService,
} from "../_services";

@Component({
  selector: "app-xenora-list",
  templateUrl: "./xenora-list.component.html",
  styleUrls: ["./xenora-list.component.css"],
})
export class XenoraListComponent implements OnInit {
  loginForm: UntypedFormGroup;
  loading = false;
  submitted = false;
  cur_page = 1;
  from = 0;
  perPage = 10;
  pageSize = 10;
  totalPages = 10;
  totalcount: any;
  search_txt = "";
  student_list = [];
  // totalcount: any;
  student: any;
  totalapayment: any;
  roleId = localStorage.getItem(`${environment.appName}` + "_role");

  @ViewChild("downloadZipLink")
  private downloadZipLink: ElementRef;

  studentcron: any;
  fileType: any;
  file: any;

  constructor(
    private setting: SettingsService,
    private formBuilder: UntypedFormBuilder,
    private authenticationService: AuthenticationService,
    private modalService: ModalService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private _marathon: MarathonService,
    private http: HttpClient,
    private router: Router
  ) {}
  public async reportDown(): Promise<void> {
    this.submitted = true;
    // this.loading = true;
    this.loading = false;
  }
  ngOnInit() {
    this._marathon.getXenorapaymentcount().subscribe((data) => {
      this.totalapayment = data.data[0].total_amount;
    });

    this.refresh(true);
  }

  public async downloadExcel() {
    // if(this.roleId == '100'){
    // const blob = await this._marathon.getPaymentListDownload(this.cur_page, this.search_txt, this.selected_category, this.selected_tshirt,"fhg");
    const blob = await this._marathon.getXenoraDownload();
    let binaryData = [];
    binaryData.push(blob);
    const url = window.URL.createObjectURL(
      new Blob(binaryData, { type: "application/ms-excel" })
    );
    const link = this.downloadZipLink.nativeElement;
    link.href = url;
    link.download = "Payment.xlsx";
    link.click();
    // }
  }

  refresh(reset = false) {
    this.loading = true;

    this._marathon.getXenoraRegList(this.cur_page, this.search_txt).subscribe(
      (data) => {
        console.log(data, "fhjksdhgfkasdhf");
        this.loading = false;
        this.student_list = data.data.docs;
        console.log(this.student_list);
        this.totalcount = data.data.totalDocs;
        this.from = data.data.pagingCounter;
        this.cur_page = data.data.page;
        this.totalPages = data.data.totalPages;
      },
      (error) => {}
    );
  }

  search(e) {
    e.stopPropagation();

    this.search_txt = e.target.value;
    console.log("kl", this.search_txt);

    this.changePage(1);

    this.loading = true;
    //   this.refresh();
    this._marathon.getXenoraRegList(this.cur_page, this.search_txt).subscribe(
      (data) => {
        this.student_list = data.data.docs;
        this.loading = false;
        this.cur_page = data.data.page;
        this.totalcount = data.data.totalDocs;
        this.totalPages = data.data.totalPages;

        this.from = data.data.pagingCounter;
      },
      (error) => {}
    );
  }

  changePage(page) {
    this.cur_page = page;

    // this.refresh();
    var that = this;

    that._marathon.getXenoraRegList(that.cur_page, that.search_txt).subscribe(
      (data) => {
        that.student_list = data.data.docs;
        that.cur_page = data.data.page;
        that.totalcount = data.data.totalDocs;
        that.totalPages = data.data.totalPages;
        that.from = data.data.pagingCounter;
      },
      (error) => {}
    );
  }

  resetFilter(e) {
    this.search_txt = "";
    $("#search1").val("");
    this.refresh(true);
  }

  sync() {
    var that = this;
    that._marathon.getStudent().subscribe((data) => {
      that.toastr.success("Syncing is done");
    });
  }
}
